export default __webpack_public_path__ + "static/media/Photo 9 - BR - Végétalisation.e6ebfcc6.png";